import { APP_ENV, DOMAIN_SITE_URL } from './constans';
import {
  getCurrentUrl,
  getIsIFrame,
  getPostUrl,
  getRedirectUrl,
} from '../modules/auth/auth-utils';
import { openDialogAlert } from '../modules/alert/alert-actions';
import {
  PaymentMethod,
  Plan,
  Subscription,
  SubscriptionStatuses,
} from './types/generated';

export const redirectToHome = (route: string): void => {
  const isIframe = getIsIFrame();
  const redirectTo = getRedirectUrl();
  const postTo = getPostUrl();

  if (redirectTo || postTo) {
    window.location.href = redirectTo || postTo;
  } else if (isIframe) {
    window.parent.location = getCurrentUrl() as string;
  } else {
    window.location.href =
      APP_ENV !== 'local' ? 'https://vanguardia.com' : route;
  }
};

export const getReadingTime = (textHtml: string): number => {
  const container = document.createElement('div');
  container.innerHTML = textHtml;

  return Math.round((container.textContent as string).split(' ').length / 250);
};

export function formatCurrencyMXN(value: number): string {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  }).format(value);
}

export const copyToClipboard = (text: string, message?: string): void => {
  navigator.clipboard.writeText(text).then(() => {
    openDialogAlert(message ?? 'Copiado!');
  });
};

export const parseToUrl = (dynamicUrl: string): string => {
  const baseUrl = 'https://';
  let finalUrl = dynamicUrl;

  if (!dynamicUrl.startsWith('http://') && !dynamicUrl.startsWith('https://')) {
    finalUrl = baseUrl + dynamicUrl;
  }

  try {
    const parsedUrl = new URL(finalUrl);
    return parsedUrl.toString();
  } catch (error) {
    console.error(`Error parsing URL: ${dynamicUrl}`, error);
    return finalUrl;
  }
};

/*TODO: Eliminar */
export const getRedirectsOnPurchaseSub = (plan: Plan): string => {
  if (plan) {
    if (plan.title_front?.toLowerCase().includes('estándar')) {
      return DOMAIN_SITE_URL + '/gracias-por-suscribirte?sub-type=monthly-sub';
    } else if (plan.title_front?.toLowerCase()?.includes('profesional')) {
      return DOMAIN_SITE_URL + '/gracias-por-suscribirte?sub-type=yearly-sub';
    } else {
      return DOMAIN_SITE_URL + '/gracias-por-suscribirte?sub-type=student-sub';
    }
  }
  return '';
};

export const userCanUpdateSub = (
  subscription: Subscription | undefined | null,
): boolean => {
  if (!subscription) return true;
  if (subscription.status != SubscriptionStatuses.Active) return true;
  if (
    subscription.payment_method === PaymentMethod.StripeCard &&
    subscription.status === SubscriptionStatuses.Active
  ) {
    return true;
  }
  return false;
};

export const isSpecificActiveSub = (
  subs: (Subscription | null)[] | undefined | null,
  type: string,
): boolean => {
  if (!subs) return false;
  const isThisSub = subs.some(
    (sub) =>
      sub?.status === SubscriptionStatuses.Active &&
      sub?.plan?.title?.toLowerCase()?.includes(type),
  );
  return isThisSub;
};

export const atLeastOneSubActive = (
  subs: (Subscription | null)[] | undefined | null,
): boolean => {
  if (!subs) return false;
  const isThisSub = subs.some(
    (sub) => sub?.status === SubscriptionStatuses.Active,
  );
  return isThisSub;
};
